import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { PrelanderGamePage } from './pages/PrelanderGamePage';
import { PrelanderLimitedOfferPage } from './pages/PrelanderLimitedOfferPage';
import { PrelanderV3Page } from './pages/PrelanderV3Page';
import { PrelanderV4Page } from './pages/PrelanderV4Page';
import { PrelanderV5Page } from './pages/PrelanderV5Page';
import { PrelanderV6Page } from './pages/PrelanderV6Page';
import { PrelanderV7Page } from './pages/PrelanderV7Page';
import { amplitudeTracker } from './lib/shared/amplitude-tracker';
import { ga4Tracker } from './lib/shared/ga4-tracker';
import { logEvent } from './lib/shared/event-logger';
import { EVENT_TYPES } from './lib/shared/event-types';
import { setCustomHeightVariable } from './lib/shared/dimensions';
import { initSentry } from './lib/shared/sentry';
import config from './config';
import './lib/shared/twitter-tracker';
import './lib/shared/facebook-tracker';
import './lib/shared/gtag-tracker';
import './common.css';

amplitudeTracker.init(config.apiKeyAmplitude);
initSentry(config);

function App() {
    useEffect(() => {
        setCustomHeightVariable();
        window.addEventListener('resize', setCustomHeightVariable);
        ga4Tracker.init(config?.ga4TrackerId);
        logEvent(EVENT_TYPES.PAGE_VIEW);
    }, []);

    return (
        <BrowserRouter>
            <Routes>
               <Route
                    path='*'
                    element={<PrelanderGamePage />}
                />
                <Route
                    path='/v2'
                    element={<PrelanderLimitedOfferPage />}
                />
                <Route
                    path='/v3'
                    element={<PrelanderV3Page />}
                />
                <Route
                    path='/v4'
                    element={<PrelanderV4Page />}
                />
                <Route
                    path='/v5'
                    element={<PrelanderV5Page />}
                />
                <Route
                    path='/v6'
                    element={<PrelanderV6Page />}
                />
                 <Route
                    path='/v7'
                    element={<PrelanderV7Page />}
                />
            </Routes>
        </BrowserRouter>
    );
}

const root = createRoot(document.getElementById('root'));

root.render(<App />);
